import React, { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import { useNavigate, useLocation } from 'react-router-dom';
import ImageSelectionModal from './ImageSelectionModal';
import CheckboxAsButton from '../../component/CheckboxAsButton';
import { toast } from "../../Utills/toast";
import './menuForm.css';
import { useDispatch, useSelector } from 'react-redux';
import { firstLatterCap } from '../../Utills/utils';
import { updateItem, editMenuItem, fetchTaxRequest } from '../../redux/action';
import { diet } from '../../Utills/enums'
import MenuItemAddonSection from "./MenuItemAddonSection";
import { buildMenuSizeOptions, normalizeTaxCategoryId } from "./menuItemPayload";
import LocalizedContentFields from '../../component/LocalizedContentFields/LocalizedContentFields';
import { emptyContentTranslations } from '../../i18n/contentTranslationApi';
import { useTranslation } from 'react-i18next';

const FormMenuItem = ({ showAddFood = () => { }, categoryId, popupMode = false, formId = "food-item-form" }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const [itemOverrides, setItemOverrides] = useState([]);
  // const labelList = ['Spicy', 'Dry', 'Vegan', 'Gluten-Free']; // Example labels, can be modified as needed
  const labelList = [
    { name: 'Spicy', icon: '', id: 1 },
    { name: 'Bestseller', icon: '', id: 2 },
    { name: 'Gluten-Free', icon: '', id: 3 },
    { name: 'Sweet', icon: '', id: 4 },
    { name: 'No Onion Garlic', icon: '', id: 5 },
    { name: 'New', icon: '', id: 6 },
    { name: 'Chef Special', icon: '', id: 7 },
    { name: 'Jain', icon: '', id: 8 },
    { name: 'Dry', icon: '', id: 9 },
    { name: 'Gravy', icon: '', id: 10 }
  ]; // Example labels, can be modified as needed Sweet


  const menuInfo = useSelector((state) => state?.admin?.update);
  const edit = useSelector((state) => state?.admin?.edit);
  const menuItemSaving = useSelector((state) => Boolean(state?.admin?.menuItemSaving));
  const menuItemSaveError = useSelector((state) => state?.admin?.menuItemSaveError);
  const menu = useSelector((state) => state?.user?.menu);
  const taxSettings = useSelector((state) => state?.admin?.tax);
  const [checked, setChecked] = useState(true);
  const menuUpdate = menu?.categories?.find(cat => cat.categoryId === menuInfo?.selectedTabId)?.items?.find(item => item.id === menuInfo?.id) || {};
  //const category = menu?.categories?.find(cat => cat.catId === menuInfo?.selectedTab);
  const options = [
    { key: 'veg', label: 'Veg', icon: '🌿', foodTypeId: 1 },
    { key: 'nonveg', label: 'Non-veg', icon: '🍗', foodTypeId: 2 },
    { key: 'vegan', label: 'Vegan', icon: '🌱', foodTypeId: 3 },
    { key: 'egg', label: 'Egg', icon: '🥚', foodTypeId: 4 }];
  const { category, allCategories } = location.state || {};
  const isMenuEditPage = location.pathname.includes("menu-edit");
  const categoriesAvailable = [{ value: '0', label: '... Select Category...' },
  ...(
    menu?.categories?.length > 0
      ? menu.categories.map(cat => ({
        value: cat.categoryId,
        label: cat.categoryName
      })) 
      : Array.isArray(allCategories) && allCategories.length > 0
        ? allCategories.map(cat => ({
          value: cat.categoryId,
          label: cat.categoryName
        }))
        : category?.categoryId
          ? [{ value: category.categoryId, label: category.categoryName }]
        : []
  )
  ];


  // categoriesAvailable.push({ value: 'add_new', label: 'Add new category...' });
  // categoriesAvailable.push({ value: '0', label: '.. Select Category...' });
  //-----------------------

  //-----------------------
  const initialFormData = {
    categoryName: menuInfo?.categoryName || edit?.categoryName || category?.categoryName || "",
    foodName: menuUpdate?.name || edit?.foodName || "",
    description: menuUpdate?.description || edit?.description || '',
    price: menuUpdate?.price || edit?.price || '',
    imageUrl: menuUpdate?.imageUrl || edit?.imageUrl || '',//|| 'https://github.com/user-attachments/assets/fc5a949f-8931-4c3f-bab5-7db4164f732a', // This will now only be set by the image selection modal
    // imageFile: null, // This will be set by the file input
    categoryId: menuInfo?.categoryId || edit?.categoryId || category?.categoryId || "",
    menuId: menuInfo?.menuId || edit?.menuId || "00000000-0000-0000-0000-000000000000",
    foodTasteId: menuUpdate?.foodTasteId || edit?.foodTasteId || 5,
    foodTasteMapping: menuUpdate?.foodTasteMapping || edit?.foodTasteMapping || [],
    isAvailable: menuUpdate?.isAvailable ?? edit?.isAvailable ?? 1,
    labels: menuUpdate.labels || {},
    hasVariants: (menuUpdate?.menuSizeOptions?.length > 0 || edit?.menuSizeOptions?.length > 0) || false,
    menuSizeOptions: menuUpdate?.menuSizeOptions || edit?.menuSizeOptions || [{ sizeName: '', price: '' }],
    taxCategoryId: menuUpdate?.taxCategoryId || edit?.taxCategoryId || '',
    hsnSacCode: menuUpdate?.hsnSacCode || edit?.hsnSacCode || '',
    isTaxExempt: menuUpdate?.isTaxExempt ?? edit?.isTaxExempt ?? false,
    isDiscountEligible: menuUpdate?.isDiscountEligible ?? edit?.isDiscountEligible ?? true,
    diet: (() => {
      const foodType = menuUpdate?.foodTypeId || edit?.foodTypeId;
      if (foodType === 1) return 'Veg';
      if (foodType === 2) return 'Non-Veg';
      if (foodType === 3) return 'Vegan';
      if (foodType === 4) return 'Egg';
      return 'Veg';
    })(),
    // 1st letter capitalized, rest lowercase
    foodTypeId: (() => {
      const diet = firstLatterCap(menuUpdate?.diet || edit?.diet || 'Veg');
      if (diet === 'Veg') return 1;
      if (diet === 'Non-Veg') return 2;
      if (diet === 'Vegan') return 3;
      if (diet === 'Egg') return 4;
      return 0;
    })(),

    labels: (() => {
      // 1. ALWAYS create a deep copy to avoid mutating Redux state
      const existingLabels = JSON.parse(JSON.stringify(menuUpdate?.labels || edit?.labels || {}));

      // 2. Use the most reliable source for the ID
      const currentTasteId = menuUpdate?.foodTasteId || edit?.foodTasteId;

      if (currentTasteId && currentTasteId !== 0) {
        const tasteLabel = labelList.find(l => l.id === currentTasteId);
        if (tasteLabel) {
          existingLabels[currentTasteId] = {
            ...tasteLabel,
            checked: true
          };
        }
      }
      return existingLabels;
    })(),
  };
  const [formData, setFormData] = useState(initialFormData);
  const [thumbnailUrl, setThumbnailUrl] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showNewCategoryInput, setShowNewCategoryInput] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState('');

  const [categories, setCategories] = useState(categoriesAvailable);
  const [translations, setTranslations] = useState(emptyContentTranslations);
  const saveLockRef = useRef(false);

  useEffect(() => {
    if (!menuItemSaving) saveLockRef.current = false;
  }, [menuItemSaving]);

  useEffect(() => { dispatch(fetchTaxRequest()); }, [dispatch]);

  // const [categories, setCategories] = useState([
  //   { value: '', label: 'Select a category' },
  //   { value: 'Appetizers', label: 'Appetizers' },
  //   { value: 'Main Course', label: 'Main Course' },
  //   { value: 'Bread', label: 'Bread' },
  //   { value: 'Desserts', label: 'Desserts' },
  //   { value: 'Beverages', label: 'Beverages' },
  //   { value: 'add_new', label: 'Add new category...' },
  // ]);



  // const handleLabelSelect = (labelObj) => {
  //   setFormData((prevData) => {
  //     const isCurrentlyChecked = prevData.labels[labelObj.id]?.checked || false;

  //     // 1. Force a reset based on your master list of labels
  //     const resetLabels = {};
  //     labelList.forEach(l => {
  //       resetLabels[l.id] = { ...l, checked: false };
  //     });

  //     return {
  //       ...prevData,
  //       foodTasteId: !isCurrentlyChecked ? labelObj.id : 0,
  //       labels: {
  //         ...resetLabels, // All others are now false
  //         [labelObj.id]: {
  //           ...labelObj,
  //           checked: !isCurrentlyChecked
  //         },
  //       },
  //     };
  //   });
  // };

  const handleLabelSelect = (labelObj) => {
  setFormData((prevData) => {
    const existingMappings = prevData.foodTasteMapping || [];
    const isAlreadySelected = existingMappings.some(m => m.foodTasteId === labelObj.id);

    let updatedMappings;
    if (isAlreadySelected) {
      // REMOVE: Filter out the taste if it was already there
      updatedMappings = existingMappings.filter(m => m.foodTasteId !== labelObj.id);
    } else {
      // ADD: Create a new mapping object matching your SQL/Entity structure
      const newMapping = {
        menuId: prevData.menuId || edit?.menuId || "00000000-0000-0000-0000-000000000000",
        foodTasteId: labelObj.id,
        isActive: true
      };
      updatedMappings = [...existingMappings, newMapping];
    }

    // Update the visual labels state so the checkboxes stay checked/unchecked
    const updatedLabels = { ...prevData.labels };
    updatedLabels[labelObj.id] = {
      ...labelObj,
      checked: !isAlreadySelected
    };

    return {
      ...prevData,
      foodTasteMapping: updatedMappings,
      labels: updatedLabels
    };
  });
};

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === 'categoryId') {
  //     // Find the selected category from your categories array
  //     const selectedCategory = categories.find(cat => cat.value === value);

  //     setFormData((prevData) => ({
  //       ...prevData,
  //       categoryId: value,
  //       categoryName: selectedCategory?.label || '',
  //     }));
  //   }
  //   else if (name === 'isAvailable') {
  //     setFormData({
  //       ...formData,
  //       isAvailable: e.target.checked ? 1 : 0, // 1 if checked, 0 if unchecked
  //     });
  //   }
  //   else {
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       [name]: value,
  //     }));
  //   }
  // };

const handleChange = (e) => {
  const { name, value, type, checked } = e.target;

  if (name === 'categoryId') {
    const selectedCategory = categories.find(cat => cat.value === value);
    setFormData((prevData) => ({
      ...prevData,
      categoryId: value,
      categoryName: selectedCategory?.label || '',
    }));
  }
  else if (name === 'isAvailable') {
    setFormData((prevData) => ({
      ...prevData,
      // If checked pass 1, if unchecked pass null (or 0)
      isAvailable: checked ? 1 : null,
    }));
  }
  else {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }
};
  const handleAddNewCategory = () => {
    if (newCategoryName.trim() === '') {
      toast.info('Please enter a category name.');
      return;
    }

    const newCatValue = newCategoryName.trim().toLowerCase().replace(/\s/g, '_');
    const newCategory = { value: newCatValue, label: newCategoryName.trim() };

    if (categories.some(cat => cat.value === newCatValue)) {
      toast.info("This category already exists.");
      return;
    }

    setCategories((prevCategories) => {
      const addNewIndex = prevCategories.findIndex(cat => cat.value === 'add_new');
      if (addNewIndex !== -1) {
        const updated = [...prevCategories];
        updated.splice(addNewIndex, 0, newCategory);
        return updated;
      }
      return [...prevCategories, newCategory];
    });

    setFormData((prevData) => ({
      ...prevData,
      categoryName: newCatValue,
    }));
    setNewCategoryName('');
    setShowNewCategoryInput(false);
  };

  // const handleImageUpload = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       imageFile: file,
  //       imageUrl: '', // Always clear imageUrl if a new file is uploaded
  //     }));

  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setThumbnailUrl(reader.result);
  //     };
  //     reader.readAsDataURL(file);
  //   } else {
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       imageFile: null,
  //     }));
  //     setThumbnailUrl('');
  //   }
  // };

  const handleImageUpload = (e) => {
  const file = e.target.files[0];
  if (file) {
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64String = reader.result; // Format: "data:image/png;base64,iVBORw0..."
      
      setFormData((prevData) => ({
        ...prevData,
        imageBase64: base64String, // Store Base64 string in state
        imageName: file.name,       // Store original file name
        imageUrl: '',               // Clear gallery URL if new file uploaded
      }));
      setThumbnailUrl(base64String); // Set preview thumbnail
    };

    reader.readAsDataURL(file); // Converts file to Base64 string
  } else {
    setFormData((prevData) => ({
      ...prevData,
      imageBase64: null,
      imageName: null,
    }));
    setThumbnailUrl('');
  }
};

  const openImageModal = () => {
    setIsModalOpen(true);
  };

  const closeImageModal = () => {
    setIsModalOpen(false);
  };

  const handleImageSelected = (selectedImageUrl) => {
    setFormData((prevData) => ({
      ...prevData,
      imageUrl: selectedImageUrl, // Set imageUrl from modal selection
      imageFile: null, // Clear imageFile if an image is selected from gallery
    }));
    setThumbnailUrl(selectedImageUrl);
    closeImageModal();
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (!formData.categoryId) {
  //     toast.info('Please select a category!');
  //     return;
  //   }

  //   // 1. Create a shallow copy
  //   let submissionData = { ...formData };

  //   if (submissionData.diet) {
  //     const normalizedDiet = submissionData.diet.toLowerCase().replace('-', '');
  //     if (normalizedDiet === 'veg') {
  //       submissionData.diet = 'Veg';
  //       submissionData.foodTypeId = 1;
  //     } else if (normalizedDiet === 'nonveg') {
  //       submissionData.diet = 'Non-Veg';
  //       submissionData.foodTypeId = 2;
  //     } else if (normalizedDiet === 'vegan') {
  //       submissionData.diet = 'Vegan';
  //       submissionData.foodTypeId = 3;
  //     } else if (normalizedDiet === 'egg') {
  //       submissionData.diet = 'Egg';
  //       submissionData.foodTypeId = 4;
  //     }
  //   }

  //   //delete submissionData.labels;
  //   if (submissionData.foodTasteMapping) {
  //   submissionData.FoodTasteMapping = submissionData.foodTasteMapping.map(m => ({
  //   ...m,
  //   // Ensure menuId is synced if it was changed during the form session
  //   menuId: submissionData.menuId 
  // }));
  // }

  //   // 2. Safely filter labels
  //   if (submissionData.labels) {
  //     const labelIdsToFilterOut = Object.keys(submissionData.labels).filter((key) =>
  //       submissionData.labels[key]?.onlyFor
  //         ? submissionData.labels[key].onlyFor.toLowerCase() !== (submissionData.diet || '').toLowerCase()
  //         : false
  //     );
  //     labelIdsToFilterOut.forEach((id) => delete submissionData.labels[id]);
  //   }

  //   console.log('Payload:', submissionData);

  //   //3. Handle Price vs Multiple Sizes with safety checks
  //   if (submissionData.hasVariants && submissionData.menuSizeOptions) {
  //     // Map existing sizeOptions to the API-expected name
  //     submissionData.MenuSizeOptions = submissionData.menuSizeOptions.map(opt => ({
  //       ...opt,
  //       price: parseFloat(opt.price) || 0,
  //       // Ensure we don't send any empty strings as Guids
  //       menuId: edit.menuId || "00000000-0000-0000-0000-000000000000",
  //       sizeOptionId: opt.sizeOptionId || "00000000-0000-0000-0000-000000000000"
  //     }));
  //     submissionData.price = 0;
  //   } else {
  //     submissionData.menuSizeOptions = [];
  //     submissionData.price = parseFloat(submissionData.price) || 0;
  //   }

  //   // 4. Cleanup internal state keys before sending to API
  //   // We use the 'delete' keyword on the copy, not the original state
  //   delete submissionData.menuSizeOptions;
  //   delete submissionData.hasVariants;

  //   console.log('Final Payload:', submissionData);

  //   // 5. Dispatch
  //   if (!edit.menuId) {
  //     dispatch({ type: 'ADD_MENU_ITEM', payload: submissionData });
  //   } else {
  //     dispatch(updateItem(submissionData));
  //   }

  //   // 6. Navigation
  //   if (isMenuEditPage) {
  //     navigate(-1);
  //   } else if (edit?.menuId) {
  //     dispatch({ type: 'EDIT_MENU_ITEM', payload: {} });
  //   } else {
  //     showAddFood(false);
  //   }
  // };

// FormMenuItem.js -> handleSubmit
const handleSubmit = (e) => {
  e.preventDefault();
  if (menuItemSaving || saveLockRef.current) return;

  if (!formData.categoryId || formData.categoryId === "0") {
    toast.info('Please select a category.');
    return;
  }

  if (!formData.foodName?.trim()) {
    toast.info('Please enter the food item name.');
    return;
  }

  if (!formData.hasVariants && (!formData.price || Number(formData.price) <= 0)) {
    toast.info('Please enter a valid price greater than zero.');
    return;
  }

  if (formData.hasVariants && formData.menuSizeOptions?.some((option) => !option.sizeName?.trim() || Number(option.price) <= 0)) {
    toast.info('Please enter a name and valid price for every size or portion.');
    return;
  }

  saveLockRef.current = true;

  let submissionData = { ...formData };
  submissionData.taxCategoryId = normalizeTaxCategoryId(submissionData.taxCategoryId);

  const activeMenuId = edit?.menuId 
    ? edit.menuId 
    : (submissionData.menuId && submissionData.menuId !== "00000000-0000-0000-0000-000000000000" && submissionData.menuId !== "13ba2cf3-a197-4024-9040-9cae3de5e4da"
        ? submissionData.menuId 
        : (typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
            const r = Math.random() * 16 | 0;
            return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16);
          })));

  submissionData.menuId = activeMenuId;
  submissionData.translations = translations;

  // Diet / Normalization
  if (submissionData.diet) {
    const normalizedDiet = submissionData.diet.toLowerCase().replace('-', '');
    if (normalizedDiet === 'veg') {
      submissionData.diet = 'Veg';
      submissionData.foodTypeId = 1;
    } else if (normalizedDiet === 'nonveg') {
      submissionData.diet = 'Non-Veg';
      submissionData.foodTypeId = 2;
    } else if (normalizedDiet === 'vegan') {
      submissionData.diet = 'Vegan';
      submissionData.foodTypeId = 3;
    } else if (normalizedDiet === 'egg') {
      submissionData.diet = 'Egg';
      submissionData.foodTypeId = 4;
    }
  }

  if (submissionData.foodTasteMapping) {
    submissionData.FoodTasteMapping = submissionData.foodTasteMapping.map(m => ({
      ...m,
      menuId: activeMenuId
    }));
  }

  if (submissionData.hasVariants && submissionData.menuSizeOptions) {
    submissionData.MenuSizeOptions = buildMenuSizeOptions(
      submissionData.menuSizeOptions,
      activeMenuId
    );
    submissionData.price = 0;
  } else {
    submissionData.MenuSizeOptions = [];
    submissionData.price = parseFloat(submissionData.price) || 0;
  }

  delete submissionData.labels;
  delete submissionData.foodTasteMapping;
  delete submissionData.menuSizeOptions;
  delete submissionData.hasVariants;

  // ⭐ Item overrides ko payload ke sath attach karein
  submissionData.itemOverrides = itemOverrides || [];

  if (!edit?.menuId) {
    dispatch({ type: 'ADD_MENU_ITEM', payload: submissionData });
  } else {
    dispatch(updateItem(submissionData));
  }

  if (!popupMode) {
    if (isMenuEditPage) {
      navigate(-1);
    } else if (edit?.menuId) {
      dispatch({ type: 'EDIT_MENU_ITEM', payload: {} });
    } else {
      showAddFood(false);
    }
  }
};

  const handleCancel = () => {
    setFormData(initialFormData);
    setThumbnailUrl('');
    //setNewCategoryName('');
    //setShowNewCategoryInput(false);
    if (isMenuEditPage)
      navigate(-1);
    else
      if (edit?.menuId)
        dispatch({ type: 'EDIT_MENU_ITEM', payload: {} });
      else
        showAddFood(false);
    // navigate(-1);
  };

  const handleToggle = (key) => {

    let dietLabel = '';
    let foodTypeId = 1;
    if (key === 'veg') {
      dietLabel = 'Veg';
      foodTypeId = 1;
    } else if (key === 'nonveg') {
      dietLabel = 'Non-Veg';
      foodTypeId = 2;
    } else if (key === 'vegan') {
      dietLabel = 'Vegan';
      foodTypeId = 3;
    }else if (key === 'egg') {
      dietLabel = 'Egg';
      foodTypeId = 4;
    }

    setFormData((prevData) => ({
      ...prevData,
      diet: dietLabel,
      foodTypeId,
    }));
  }


  const handleSizeChange = (index, e) => {
    const { name, value } = e.target;
    const newSizeOptions = [...formData.menuSizeOptions];
    newSizeOptions[index][name] = value;

    setFormData({ ...formData, menuSizeOptions: newSizeOptions });
  };

  const addSizeRow = () => {
    setFormData({
      ...formData,
      menuSizeOptions: [...formData.menuSizeOptions, { sizeName: '', price: '' }]
    });
  };

  const removeSizeRow = (index) => {
    const newSizeOptions = formData.menuSizeOptions.filter((_, i) => i !== index);
    setFormData({ ...formData, menuSizeOptions: newSizeOptions });
  };

  return (

    <div className={popupMode ? "menu-item-popup-form" : ""} style={popupMode ? undefined : formContainerStyle}>
      {!popupMode && <h2>{edit?.menuId ? 'Edit Product Form' : 'Add Product Form'}</h2>}
      {!popupMode && <div>
        <button
          onClick={() => {
            handleCancel(false);
            // Reset edit state when closing the form
            dispatch({ type: 'EDIT_MENU_ITEM', payload: {} });
          }}
          style={{
            position: 'absolute',
            top: '65px',
            paddingLeft: "230px",
            background: 'transparent',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            color: "var(--ui-muted)"
          }}
          aria-label="Close Add Menu Item"
        >
          &#10005;
        </button>
      </div>}
      <form id={formId} onSubmit={handleSubmit}>
        {popupMode && menuItemSaveError && (
          <div className="menu-item-form-error" role="alert">
            {menuItemSaveError}
          </div>
        )}

        <div className="menu-item-primary-row" style={rowStyle}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Name</label>
            <input
              type="text"
              name="foodName"
              value={formData.foodName || ''}
              onChange={handleChange}
              required
              style={inputStyle}
            />
          </div>
          {!formData.hasVariants && (
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Amount</label>
              <input
                type="number"
                name="price"
                min="0"
                value={formData.price}
                onChange={handleChange}
                style={inputStyle}
              />
            </div>)}



        </div>
        {/* Checkbox Toggle */}
        <div style={{ ...formIsAvailableStyle, marginTop: '10px' }}>
          <label style={labelStyle}>Has Multiple Sizes / Portions?</label>
          <input
            type="checkbox"
            name="hasVariants"
            checked={formData.hasVariants}
            onChange={(e) => setFormData({ ...formData, hasVariants: e.target.checked })}
            style={{ maxHeight: '18px', width: '18px' }}
          />
        </div>

        {/* Conditional Rendering */}
        {formData.hasVariants && (
          /* SHOW THIS WHEN CHECKED */
          <div style={{ marginTop: '15px', border: "1px solid var(--ui-surface-muted)", padding: '15px', borderRadius: '8px', backgroundColor: "var(--ui-surface-muted)" }}>
            <label style={labelStyle}>Portion Prices (e.g. 30ml, Full, Regular):</label>

            {formData.menuSizeOptions?.map((option, index) => (
              <div key={index} style={{ display: 'flex', gap: '10px', marginBottom: '10px', alignItems: 'center' }}>
                <input
                  type="text"
                  placeholder="Size (e.g. 30ml)"
                  name="sizeName"
                  value={option.sizeName}
                  onChange={(e) => handleSizeChange(index, e)}
                  style={{ ...inputStyle, flex: 2 }}
                />
                <input
                  type="number"
                  placeholder="Price"
                  name="price"
                  min="0"
                  required={formData.hasVariants}
                  value={option.price}
                  onChange={(e) => handleSizeChange(index, e)}
                  style={{ ...inputStyle, flex: 1 }}
                />

                <span
                  type="button"
                  onClick={() => removeSizeRow(index)}
                  style={{ background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer' }}
                >
                  ✖
                </span>

              </div>
            ))}

            <button
              type="button"
              onClick={addSizeRow}
              style={{ ...addNewCategoryButtonStyle, width: '100%', marginTop: '5px', backgroundColor: "var(--ui-primary)" }}
            >
              + Add Size Option
            </button>
          </div>
        )}


        <div style={formGroupStyle}>
          <label htmlFor="description" style={labelStyle}>Description:</label>
          <textarea
            type="text"
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            style={inputStyle}
          />
        </div>

        <LocalizedContentFields
          entityType="menu"
          entityId={edit?.menuId}
          value={translations}
          onChange={setTranslations}
          fields={[
            { name: 'name', label: 'Translated name', placeholder: 'Enter translated food name' },
            { name: 'description', label: 'Translated description', placeholder: 'Enter translated description', multiline: true }
          ]}
        />

        <div style={formGroupStyle}>
          <label htmlFor="categoryId" style={labelStyle}>Category:</label>
          <Select
            id="categoryId"
            name="categoryId"
            // Find the current category object to show as the value
            value={categories.find(cat => cat.value === formData.categoryId)}
            // Update formData when an option is selected
            onChange={(selectedOption) => {
              setFormData({
                ...formData,
                categoryId: selectedOption ? selectedOption.value : "",
                categoryName: selectedOption && selectedOption.value !== "0"
                  ? selectedOption.label
                  : ""
              });
            }}
            options={categories}
            placeholder="Search Category..."
            isSearchable={true} // This enables the search bar
            isClearable={true}
            styles={formGroupStyle}
          />
        </div>

        <section className="menu-tax-section">
          <div className="menu-tax-heading"><strong>{t("Tax & billing")}</strong><span>{t("Applied when this item is billed.")}</span></div>
          <div className="menu-tax-grid">
            <label><span>{t("Tax category")}</span><select name="taxCategoryId" value={formData.taxCategoryId || ''} onChange={handleChange}><option value="">{t("Restaurant default")}</option>{(taxSettings?.taxCategories || []).map((item) => <option key={item.taxCategoryId} value={item.taxCategoryId}>{item.name} ({item.isTaxExempt ? t('Exempt') : `${Number(item.cgstPercent) + Number(item.sgstPercent)}%`})</option>)}</select></label>
            <label><span>{t("HSN / SAC code")}</span><input name="hsnSacCode" value={formData.hsnSacCode || ''} onChange={handleChange} placeholder={t("Uses category code if empty")} /></label>
          </div>
          <div className="menu-tax-options">
            <label><input type="checkbox" name="isTaxExempt" checked={Boolean(formData.isTaxExempt)} onChange={(e) => setFormData((current) => ({ ...current, isTaxExempt: e.target.checked }))} /> {t("Tax exempt item")}</label>
            <label><input type="checkbox" name="isDiscountEligible" checked={Boolean(formData.isDiscountEligible)} onChange={(e) => setFormData((current) => ({ ...current, isDiscountEligible: e.target.checked }))} /> {t("Eligible for bill discount")}</label>
          </div>
          <small>{t("Use Tax exempt for packaged water or other items where tax must not be charged.")}</small>
        </section>

        {/* <div style={formIsAvailableStyle}>
          <label htmlFor="isAvailable" style={isAvailableStyle}>Is Available:</label>
          <input
            type="checkbox"
            id="isAvailable"
            name="isAvailable"
            value={formData.isAvailable}
            onChange={handleChange}
            checked={formData.isAvailable === undefined || formData.isAvailable === 1}
            style={{ maxHeight: '18px', width: '18px' }}
          />
        </div> */}

<div style={formIsAvailableStyle}>
  <label htmlFor="isAvailable" style={isAvailableStyle}>Is Available:</label>
  <input
    type="checkbox"
    id="isAvailable"
    name="isAvailable"
    onChange={handleChange}
    checked={formData.isAvailable === 1}
    style={{ maxHeight: '18px', width: '18px' }}
  />
</div>
        <div style={formGroupStyle}>
          <label style={labelStyle}>Click to select Labels suitable for the item:</label>

          <div className="diet-type-container">
            {options.map((opt) => {
              return (
                <label key={opt.key} className="diet-card">
                  <input
                    type="radio"
                    id="diet"
                    name="diet"
                    value={opt.key}
                    checked={formData.diet.toLowerCase().replace('-', '') === opt.key}
                    onChange={() => handleToggle(opt.key)}
                  />
                  <span className="diet-icon">{opt.icon}</span>
                  <span className="diet-text">{opt.label} </span>
                </label>
              );
            })}
          </div>

          {labelList.filter((label) => formData.diet === label.onlyFor || !label.onlyFor).map((label, index) => (
            // <button key={index} style={{ marginRight: '5px' }} type='checkbox'>{label} <span>X</span></button>
            <CheckboxAsButton
              key={label.id}
              checked={formData.foodTasteMapping.some(m => m.foodTasteId === label.id)}
              onChange={() => handleLabelSelect(label)}
              // checked={formData.labels[label.id]?.checked || false}
              // onChange={handleLabelSelect}
              children={label} // Pass the object here
            />
            // <React.Fragment key={index}>
            //   <input key={index} style={{ marginRight: '5px', border: '2px' }} type='checkbox' value={label} name={label} />
            //   <label for={label}> {label}</label>
            // </React.Fragment>
          ))}
        </div >

        <MenuItemAddonSection
  categoryId={formData.categoryId}
  menuId={formData.menuId || edit?.menuId}
  itemOverrides={itemOverrides}
  setItemOverrides={setItemOverrides}
/>

        <div style={formGroupStyle}>
          <label style={labelStyle}>Image (Optional):</label> {/* Label updated for clarity */}
          {/* Removed the text input for Image URL */}
          <input
            type="file"
            id="imageUpload"
            accept="image/*"
            onChange={handleImageUpload}
            style={{ display: 'none' }}
          />
          <label htmlFor="imageUpload" style={browseButtonStyle}>
            Upload from device
          </label>
          <button type="button" onClick={openImageModal} style={browseButtonStyle}>
            Browse Images
          </button>
        </div>

        {thumbnailUrl && (
          <div style={thumbnailContainerStyle}>
            <p style={labelStyle}>Image Thumbnail:</p>
            <img
              src={thumbnailUrl}
              alt="Thumbnail"
              style={thumbnailStyle}
            />
          </div>
        )}

        {!popupMode && <div style={formActionsStyle}>
          <button type="submit" className="form-btn">Submit</button>
          <button type="button" onClick={handleCancel} style={cancelButtonStyle}>Cancel</button>
        </div>}
      </form>

      {isModalOpen && (
        <ImageSelectionModal
          onClose={closeImageModal}
          onSelectImage={handleImageSelected}
        />
      )}
    </div>
  );
};

const rowStyle = {
  display: 'flex',
  gap: '15px',
};


const formContainerStyle = {
  maxWidth: '600px',
  margin: '50px auto',
  padding: '20px',
  border: "1px solid var(--ui-border)",
  borderRadius: '8px',
  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
  fontFamily: 'Arial, sans-serif',
};

const customSelectStyles = {
  control: (provided) => ({
    ...provided,
    ...inputStyle, // Inherit your existing input styles
    display: 'flex',
    padding: '0', // react-select has its own padding
    border: '1px solid #ccc',
    borderRadius: '8px'
  })
};

const formGroupStyle = {
  marginBottom: '18px',
};

const labelStyle = {
  display: 'block',
  marginBottom: '5px',
  fontWeight: 'bold',
  color: "var(--ui-text)",
  textAlign: 'left',
  fontSize: '14px',
};

const formIsAvailableStyle =
{
  display: "flex",
  alignItems: "center",
  gap: "10px", // spacing between label and checkbox
  marginBottom: "10px"
}

const isAvailableStyle = {
  display: 'block',
  marginBottom: '5px',
  fontWeight: 'bold',
  color: "var(--ui-text)",
  textAlign: 'left',
  fontSize: '14px',
  with: '20%'
};

const inputStyle = {
  width: '100%',
  padding: '10px',
  border: "1px solid var(--ui-border)",
  borderRadius: '4px',
  boxSizing: 'border-box',
};

const browseButtonStyle = {
  backgroundColor: "var(--ui-primary)",
  color: "var(--ui-on-primary)",
  padding: '10px 15px',
  borderRadius: '4px',
  cursor: 'pointer',
  border: 'none',
  display: 'inline-block',
  marginTop: '5px',
  marginRight: '10px'
};

const thumbnailContainerStyle = {
  marginTop: '20px',
  textAlign: 'center',
};

const thumbnailStyle = {
  maxWidth: '200px',
  maxHeight: '200px',
  marginTop: '10px',
  border: "1px solid var(--ui-border)",
  borderRadius: '4px',
  objectFit: 'contain',
};

const submitButtonStyle = {
  backgroundColor: "var(--ui-success)",
  color: "var(--ui-on-primary)",
  padding: '10px 20px',
  borderRadius: '4px',
  border: 'none',
  cursor: 'pointer',
  fontSize: '16px',
};

const newCategoryInputGroupStyle = {
  display: 'flex',
  marginTop: '10px',
  gap: '10px',
};

const newCategoryInputStyle = {
  flexGrow: 1,
  padding: '10px',
  border: '1px solid #ddd',
  borderRadius: '4px',
  boxSizing: 'border-box',
};

const addNewCategoryButtonStyle = {
  backgroundColor: '#6c757d',
  color: 'white',
  padding: '10px 15px',
  borderRadius: '4px',
  border: 'none',
  cursor: 'pointer',
};

const formActionsStyle = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '10px',
  marginTop: '20px',
  paddingTop: '15px',
  borderTop: "1px solid var(--ui-surface-muted)",
};

const cancelButtonStyle = {
  backgroundColor: '#dc3545',
  color: "var(--ui-on-primary)",
  padding: '10px 20px',
  borderRadius: '4px',
  border: 'none',
  cursor: 'pointer',
  fontSize: '16px',
};


export default FormMenuItem;


